<script>
// helpers
import { baseComputed } from '@state/helpers/base.js'

// scss
import '@src/design/components/page-title.scss'
export default {
    computed: {
        ...baseComputed,
    },
    methods: {
        changeRoute() {
            if (this.$route.params.responsibleId)
                return this.$router.push({
                    name: 'Menu.editResponsible',
                    params: { id: this.$route.params.responsibleId },
                })
            return this.$router.go(-1)
        },
    },
}
</script>
<template>
    <div class="title">
        <b-container fluid>
            <div class="title__container">
                <b-row>
                    <b-col class="d-flex align-items-center">
                        <div
                            v-if="$route.meta.backButton"
                            class="title__container-backContainer"
                            @click.prevent="changeRoute"
                        >
                            <a class="title__container-backButton" />
                        </div>
                        <transition name="fade" mode="out-in">
                            <h1 class="title__container-text">
                                {{ pageTitle || $t($route.name) }}
                            </h1>
                        </transition>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/page-title';
</style>
